<ng-template #content>
    <div *ngIf="tableReady">
    <app-table [table]="table"></app-table>
  </div>
  <div *ngIf="!tableReady" class="loading-spinner-container">
    <div class="spinner-border text-primary loading-spinner-md" role="status">
      <span class="visually-hidden-focusable">Loading...</span>
    </div>
  </div>
</ng-template>

<ng-template #userView>
  <main id="transactions">
    <div class="card">
      <nav>
        <div class="nav-tab" id="nav-tab" role="tablist">
          <ul ngbNav #nav="ngbNav" [activeId]="activeTab" class="nav-tabs nav-pills">
            <li class="nav-item" [ngbNavItem]="'summary'" domId="tab_trasactions">
              <a class="nav-link me-2 ps-2" ngbNavLink disabled>
                <app-svg source="icons/feather/zap" height="18"></app-svg>
                <span>Ladevorgänge</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div class="card-body">
        <div class="clearfix">
          <form class="float-start">
            <div i18n="@@Search" style="min-width:200px;">
              <input class="form-control" id="table_search" type="text" name="searchTerm" [(ngModel)]="tableFunctions.searchTerm" i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
            </div>
          </form>
          <div class="float-end mb-1">
            <app-table-filter [defaultFilter]='{"entries":"1000"}' (setFilterEvent)="setFilter($event)"></app-table-filter>
          </div>

          </div>
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </div>

        <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
          <div class="d-flex">
            <div class="flex-fill d-none d-md-inline">
              <div class="d-flex">
                <div class="flex p-2" i18n="@@Records#">Datensätze #</div>
                <div class="flex">
                  <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize" class="form-control form-select custom-select" aria-label="" (change)="tableFunctions.onPageSizeChange(className)">
                    <option [ngValue]="10">10</option>
                    <option [ngValue]="25">25</option>
                    <option [ngValue]="50">50</option>
                    <option [ngValue]="100">100</option>
                    <option [ngValue]="250">250</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
              <ngb-pagination #pagination
                              [collectionSize]="(tableFunctions.total$ | async)!"
                              [(page)]="tableFunctions.page"
                              [pageSize]="tableFunctions.pageSize"
                              [maxSize]="tableFunctions.page == 4 ? 4 : 3"
                              [boundaryLinks]="true"
                              [rotate]="true">
              </ngb-pagination>
            </div>
            <div class="flex-fill justify-content-end d-none d-md-inline">
              <div class="d-flex float-end">
                <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
                <div class="flex">
                  <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select" aria-label="">
                    <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index" [ngValue]="i + 1">{{ i + 1 }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </main>
</ng-template>

<ng-template #customerView>
  <div class="clearfix">
    <form class="float-start">
      <div i18n="@@Search" style="min-width:200px;">
        <input class="form-control" id="table_search" type="text" name="searchTerm" [(ngModel)]="tableFunctions.searchTerm" i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
      </div>
    </form>
    <div class="float-end mb-1 d-flex">
      <a class="btn btn-yellow me-2" id="creat_delivirynote" (click)="openCreateDeliveryNoteDialog()" *ngIf="permissions?.createDeliveryNotes">
        <app-svg source="icons/feather/file-text" height="18"></app-svg>
        <span class="d-none d-md-inline ps-2">Lieferschein erstellen</span>
      </a>
      <a class="btn btn-yellow" id="creat_deliverycsv" (click)="openCreateDeliveryCSVDialog()" *ngIf="permissions?.createDeliveryNotes">
        <app-svg source="icons/feather/save" height="18"></app-svg>
        <span class="d-none d-md-inline ps-2">Als CSV herunterladen</span>
      </a>
      <app-table-filter [defaultFilter]='{"entries":"1000"}' (setFilterEvent)="setFilter($event)"></app-table-filter>
    </div>
    </div>
    <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>

<ng-container *ngTemplateOutlet="determineTemplate()"></ng-container>

<router-outlet></router-outlet>
